import { ChangelogStatus } from '../types/enums/ChangelogStatus.enum';

export type ChangelogStatusStyle = {
  name: string;
  color: string;
  backgroundColor: string;
};

const STATUS_STYLES: Record<number, ChangelogStatusStyle> = {
  [ChangelogStatus.DRAFT]: { name: 'Draft', color: '#475569', backgroundColor: '#edf2f7' },
  [ChangelogStatus.PUBLISHED]: { name: 'Published', color: '#2f855a', backgroundColor: '#c6f6d5' },
};

export const getChangelogStatusStyle = (statusId: number): ChangelogStatusStyle => STATUS_STYLES[statusId];
